<template>
    <div class="relative">
		<div class=" white" style="width: 100%;" id="tool-bar">
			<v-row class="ma-0" style="width: 100%;" align="center" justify="start">
		        <v-col cols="auto" class="d-flex flex-column justify-center ">
					<slot name="breadcrumbs" :item="true"></slot>
				</v-col>
                <v-col>
                </v-col>
                <v-col cols="auto" class="d-flex align-center px-5">
                    <v-tooltip right>
                        <template v-slot:activator="{on, attrs}">
                            <div
                                v-on="on"
                                v-bind="attrs"
                            >
                                <v-btn
                                    icon
                                    :loading="materialsLoading"
                                    :disabled="changeBondStatusLoading"
                                    @click="fetchMaterials()"
                                >
                                    <v-icon  color="primary" size="18">
                                        fa-sync
                                    </v-icon>
                                </v-btn>
                            </div>
                        </template>
                        {{$t('update-materials')}}
                    </v-tooltip>
                </v-col>
			</v-row>
			<v-layout
				class="mx-3 border rounded-lg d-flex flex-row wrap"
				:class="$emerald.ifLang('es', 'justify-lg-start justify-md-end', null)"
				align="center"
			>
				<v-col cols="auto" :lg="$emerald.ifLang(['ar', 'es'], ['3', '2'], '4')" class="d-flex flex-column pe-lg-0">
                    <bee-bond-up-down
                        v-model="bondNo"
                        @keydown-enter-prevent="fetchManufacturingBond(null)"
                        @programmatically-changed="fetchManufacturingBond(null)"
                        :items="manufacturingBonds.map(c => c.no)"
                        :disabled="loading || changeBondStatusLoading"
                        class="medium-placeholder"
                        :label="$t('manufacturingBond.bond-no')"
                    ></bee-bond-up-down>
                </v-col>
                
                <!-- add button -->
                <v-col sm="auto" cols="12" class="d-flex flex-column px-lg-0">
                    <bee-btn  
                        @click="addEntryDialog = true"
                        :content="$t('manufacturingBond.add')"
                        color="addingColor"
                        context="manufacturing_bond"
                        icon="fa-plus"
                        :action-name="actions.CREATE"
                        :disabled="file_is_locked || changeBondStatusLoading"
                    ></bee-btn>
                </v-col>

                <!-- delete button -->
                <v-col v-if="!manufacturingBond.is_posted" sm="auto" cols="12" class="d-flex flex-column px-lg-0">
                    <bee-btn
                        :content="$t('manufacturingBond.delete')"
                        color="deletingColor"
                        icon="fa-trash-alt"
                        outer-class="ms-2"
                        :disabled="file_is_locked || !$route.query.id || changeBondStatusLoading"
                        @click="deleteBondDialog = true"
                        context="manufacturing_bond"
                        :action-name="actions.DELETE"
                    ></bee-btn>
                </v-col>

                <!-- document date -->
                <v-col sm="auto" cols="12" class="d-flex flex-column">
                    <bee-date-picker
                        :disabled="true || manufacturingBond.is_posted || file_is_locked"
                        context="manufacturing_bond"
                        :action-name="actions.EDIT"
                        @blur="'update()'"
                        :label="$t('manufacturingBond.bond-date')"
                        v-model="bondDate"
                        :rules="rules.date"
                        :hide-details="true"
                    ></bee-date-picker>
                </v-col>

                <v-spacer/>
                        
                <!-- add product -->
                <v-col v-if="!manufacturingBond.is_posted" cols="12" sm="auto" xs="auto" md="auto" lg="auto" class="d-flex flex-column">
                    <bee-btn  
                        @click="$router.push({
                            name: 'create-product',
                            query: { manufacturingFileId: $route.query.id }
                        })"
                        :content="$t('manufacturingBond.create-bond')"
                        color="addingColor"
                        context="manufacturing_bond"
                        icon="fa-plus"
                        :action-name="actions.DELETE"
                        :disabled="file_is_locked || !$route.query.id || changeBondStatusLoading"
                    ></bee-btn>
                </v-col>
                <v-spacer/>

                <!-- section -->
                <v-col lg="auto" sm='auto' cols="12" class="d-flex flex-column py-lg-0">
                    <bee-btn
                        v-if="
                            useUnPostingPermission
                                ? (!manufacturingBond.is_posted || (manufacturingBond.is_posted && canUnPost))
                                : true
                        "
                        context="manufacturing_bond"
                        :action-name="actions.EDIT"
                        :content="manufacturingBond.is_posted
                            ? $t('manufacturingBond.edit')
                            : $t('manufacturingBond.save')
                        " 
                        :icon="manufacturingBond.is_posted ? 'fa-envelope-open' : 'fa-envelope'" 
                        :outer-class="$vuetify.breakpoint.lgAndUp ? 'py-8': ''"
                        :disabled="file_is_locked || !$route.query.id"
                        :loading="changeBondStatusLoading"
                        :color="manufacturingBond.is_posted ? 'deletingColor' : 'blueGray'"
                        @click="manufacturingBond.is_posted? unPost(): post()"
                    >
                    </bee-btn>
                </v-col>
                <v-col lg="1" md="1" cols="12" class="d-flex flex-column"
                    :class="[
                        manufacturingBond.is_posted ?'postedColor':'unpostedColor',
                        $vuetify.breakpoint.mdAndUp ? 'border-round-end':'border-round-bottom'
                    ]"
                >
                    <span class="d-flex justify-center text-center align-center fill-height text-wrap white--text font-weight-bold" style="line-height: 1.2;">
                        {{manufacturingBond.is_posted ? '' : $t('manufacturingBond.not')}}
                        <br v-if="!manufacturingBond.is_posted && $vuetify.breakpoint.mdAndUp">
                        {{$t('manufacturingBond.posted')}}
                    </span>
                </v-col>
            </v-layout>
        </div>

        <div class="mt-2"  style="width: 100%;">
            <v-card flat>
                <v-card-text class="pt-0 px-3">
                    <bee-handy-table
                        ref="table"
                        :height="$vuetify.breakpoint.height - 295"
                        :items="tableEntries || []"
						:zebra="true"
                        :loading="loading || changeBondStatusLoading"
						empty-state="-"
                        pagination-on-scroll
                        shown-rows-text=""
                        dense
						:fixed-header="true"
						:headers="headers"
                        :disable-context-menu="file_is_locked"
                        :context-menu-items="rightClickMenuItemsFiltered"
                        @context-menu-show-details="showDetails($event.item)"
                        @context-menu-edit="editRawMaterials($event.item)"
                        @context-menu-delete="confirmDeleteEntry($event.item)"
                    >
                        <template v-slot:[`item.warehouse_id`]="{item}">
                            {{
                                warehouses
                                .find(c => c.id === materials.find(c => c.id === item.material_id).warehouse_id)
                                .name
                            }}
                        </template>
                    </bee-handy-table>
                </v-card-text>
            </v-card>
        </div>

        <!-- fixed footer -->
        <v-bottom-navigation id="footer" app class="px-3" horizontal background-color="#E1E2E4">
            <v-row align="center" justify="center" justify-lg="end">
                <!-- balance -->
                <v-col cols="auto" lg="auto" class="ma-0 pa-0 d-flex">
                    <bee-outlined-header-info
                        border-color="transparent"
                        :head="$t('manufacturingBond.total-costs')"
                        :column="false"
                    >
                        <template  v-slot:content="{}">
                            <bee-money-label
                                :number="summaryBalance"
                                empty-state="_"
                            ></bee-money-label>
                        </template>
                    </bee-outlined-header-info>
                </v-col>
            </v-row>
        </v-bottom-navigation>

        <!-- Add bond dialog -->
        <v-dialog v-model="addEntryDialog" max-width="500" transition="dialog-top-transition">
            <v-card>
                <v-card-title class="headline">
                    {{$t('manufacturingBond.create-manufacturing-bond')}}
                </v-card-title>
                <v-card-text>
                    <bee-date-picker
                      v-model="date"
                      :label="$t('manufacturingBond.manufacturing-bond-date')"
                      context="manufacturing_bond"
                      :action-name="actions.CREATE"
                      :rules="rules.date"
                    ></bee-date-picker>
                </v-card-text>
                <v-card-actions class="ms-3">
                    <v-btn color="greenDarken1" text @click="createManufacturingBond" :loading="loading" >
                        {{$t('manufacturingBond.create')}}
                    </v-btn>
                    <v-btn color="redDarken1" text @click="addEntryDialog = false" >
                        {{$t('manufacturingBond.cancel')}}
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- delete entry dialog -->
        <bee-dialog
            v-model="deleteEntryDialog"
            :title="$t('manufacturingBond.delete-entry')"
            :message="$t('manufacturingBond.are-you-sure-you-want-to-delete-the-entry')"
            @handler="deleteEntry();"
            @close="deleteEntryDialog = false"
        ></bee-dialog>
        
        <!-- delete bond dialog -->
        <bee-dialog
            v-model="deleteBondDialog"
            :title="$t('manufacturingBond.delete-journal')"
            :message="$t('manufacturingBond.are-you-sure-you-want-to-delete-the-journal')"
            @handler="deleteManufacturingBond()"
            @close="deleteBondDialog = false"
        ></bee-dialog>
    </div>
</template>

<script>
import actions from "../../../permissions/actions-names";
import store from "../../../store/index";
import rules from "../../../validation";
import EventBus from '@/event-bus';
import { mapState, mapGetters } from 'vuex';
import { useUnPostingPermission } from '@/configs/global'
export default {
    name: 'manufacturing-bond',
    
    data(){
        return {
            bondNo: null,
            bondDate: null,

            date: null,

            addEntryDialog: false,
            deleteEntryDialog: false,
            deleteBondDialog: false,

            deleteEntryId: null,
            
            loading: true,
            actions,
            rules,

            useUnPostingPermission,
            materialsLoading: false,
            changeBondStatusLoading: false
        }
    },

    computed: {
        ...mapState({
            configs:  state => state.configs.configs,
            materials:  state => state.materials.materials,
            warehouses:  state => state.warehouses.warehouses,
            manufacturingBonds:  state => state.manufacturing.manufacturingBonds,
            manufacturingBond:  state => state.manufacturing.manufacturingBond,
            entries:  state => state.manufacturing.entries,
            unitSizes: state => state.unitSizes.unit_sizes,
            canUnPost: state => state.permissions.selfPermissions.canUnPost,
        }),

        ...mapGetters({
            getBondById: 'manufacturing/getBondById',
            getBondByNo: 'manufacturing/getBondByNo',
            getMaterialById: 'materials/getMaterialById',
        }),

        rightClickMenuItems() {
            return [
                {
                    event: 'show-details',
                    class: 'text-subtitle-2',
                    title: this.$t('manufacturingBond.context-menu.show-details')
                },
                {
                    event: 'edit', 
                    class: 'text-subtitle-2',
                    title: this.$t('manufacturingBond.context-menu.edit')
                },
                {
                    event: 'delete',  
                    class: 'text-subtitle-2',
                    title: this.$t('manufacturingBond.context-menu.delete')
                },
            ]
        },

        rightClickMenuItemsFiltered(){
            if (!this.manufacturingBond.is_posted){
                return this.rightClickMenuItems.filter(c => c.event !== 'show-details')
            }
            else {
                return this.rightClickMenuItems.filter(c => c.event === 'show-details')
            }
        },

        headers() {
            return [
                {
                    text: this.$t('manufacturingBond.headers.no'),
                    name: 'no',
                    value: 'no',
                    type: 'auto_increment',
                    width: '8%',
                },
                {
                    text: this.$t('manufacturingBond.headers.warehouse'),
                    name: 'warehouse-name',
                    value: 'warehouse_name',
                    width: '15%',
                    editable: false,
                },
                {
                    text: this.$t('manufacturingBond.headers.material-name'),
                    name: 'material-name',
                    value: 'material_name',
                    // type: 'materials-autocomplete',
                    type: 'autocomplete',
                    width: '10%',
                    editable: true,
                    // settings: {
                    //     items: this.materials.filter(c => c.type == 2),
                        
                    //     itemText: 'name',
                    //     itemValue: 'id',
                    //     context: 'material',
                    //     actionName: this.actions.GET
                    // }
                },
                {
                    text: this.$t('manufacturingBond.headers.count'),
                    name: 'count',
                    value: 'count',
                    type: 'numeric',
                    width: '10%',
                    editable: true,
                    // settings: { itemText: 'name' }
                },
                {
                    text: this.$t('manufacturingBond.headers.produced-quantity'),
                    name: 'quantity',
                    value: 'quantity.quantity',
                    type: 'numeric',
                    width: '10%',
                    editable: true,
                    // settings: { itemText: 'name' }
                },
                {
                    text: this.$t('manufacturingBond.headers.unit'),
                    name: 'unit-size-name',
                    value: 'unit_size_name',
                    type: 'autocomplete',
                    width: '10%',
                    editable: true,
                    settings: {
                        items: this.unitSizes,
                        itemText: 'name',
                        itemValue: 'id'
                    }
                },
                {
                    text: this.$t('manufacturingBond.headers.loss-ratio') + '%',
                    value: 'loss_ratio',
                    type: 'numeric',
                    width: '10%',
                    editable: true,
                    // settings: { itemText: 'name' }
                },
                {
                    text: this.$t('manufacturingBond.headers.cost-of-one'),
                    value: 'cost.amount',
                    type: 'money',
                    width: '10%',
                    editable: true,
                    // settings: { itemText: 'name' }
                },
                {
                    text: this.$t('manufacturingBond.headers.total-cost'),
                    value: 'total_cost.amount',
                    type: 'money',
                    width: '13%',
                    editable: true,
                    // settings: { itemText: 'name' }
                },
            ]
        },
        tableEntries() {
            if(this.$route.query.id) {
                return this.entries.map(v => {
                    // get the material one time and add all the missing data
                    const material = this.getMaterialById(v.material_id);
                    return  ({
                        ...v,
                        warehouse_name: this.warehouses.find(t => t.id === material?.warehouse_id)?.name,
                        material_name: material.name,
                        unit_size_name: this.unitSizes.find(v => v.id === material.unit_size_id)?.name
                    })
                }) 
            } else {
                return []
            }
        },
        summaryBalance(){
            return  this.entries.length > 0
                ? this.entries.map(c => c.total_cost.amount).reduce((a, b) => a + b)
                : null;
        },

        file_is_locked(){
            return this.configs.financial_file.is_locked;
        },
    },

    methods:{
        // manufacturing bond
        fetchManufacturingBonds(){
            return this.$store.dispatch('manufacturing/fetchAll', {
                fromDate: this.configs.financial_file.start_date,
                toDate: new Date ().toISOString().substring(0, 10),
                postingStatus: 3 // 3 => all bonds
            })
        },

        fetchManufacturingBond(bondId){
            this.loading = true;
            let id;
            if (bondId){
                id = bondId;
            }
            else {
                id = this.getBondByNo(this.bondNo)?.id;
            }
            
            if (id) {
                const promises = [
                    this.fetchManufacturingBondEntries(id),
                    this.$store.dispatch('manufacturing/fetchById', { manufacturingFileId: id })
                ]
                return Promise.all(promises)
                .then(() => {
                    this.bondNo = this.manufacturingBond.no;
                    this.bondDate = this.manufacturingBond.date;
                    
                    if(!bondId){
                        this.$router.replace({ name: 'manufacturing-bond', query: { id } })
                    }
                })
                .finally(() => {
                   this.loading = false;
                })
            } else {
                this.loading = false;
            }
        },

        createManufacturingBond(){
            this.$store.dispatch('manufacturing/create', {
                date: this.date
            })
            .then((data) => {
                this.fetchManufacturingBonds()
                .then(() => {
                    this.$router.replace({ name: 'manufacturing-bond', query: { id: data } })
                    .then((route) => {
                        this.fetchManufacturingBond(route.query.id);
                    })
                })
                this.addEntryDialog= false;
            })
        },

        deleteManufacturingBond(){
            this.$store.dispatch('manufacturing/delete', {
                manufacturingFileId: this.$route.query.id
            })
            .then(() => {
                this.fetchManufacturingBonds()
                .then(() => {
                    if(this.manufacturingBonds.length) {
                        this.$router.replace({
                            name: 'manufacturing-bond',
                            query: { id: this.manufacturingBonds[this.manufacturingBonds.length - 1].id }
                        })
                        .then((route) => {
                            this.fetchManufacturingBond(route.query.id);
                        })
                    } else {
                        this.$router.replace({name: 'manufacturing-bond'})
                        this.bondNo = null;
                    }
                })
            })
        },

        post(){
            this.changeBondStatusLoading = true;
            this.$store.dispatch('manufacturing/updateToPosted', {
                manufacturingFileId: this.$route.query.id
            })
            .then(() => {
                this.fetchManufacturingBond(this.$route.query.id).finally(() => {
                    this.changeBondStatusLoading = false;
                })
                this.fetchMaterials()
            })
        },
        unPost(){
            this.changeBondStatusLoading = true;
            this.$store.dispatch('manufacturing/updateToNotPosted', {
                manufacturingFileId: this.$route.query.id
            })
            .then(() => {
                this.fetchManufacturingBond(this.$route.query.id).finally(() => {
                    this.changeBondStatusLoading = false;
                })
                this.fetchMaterials()
            })
        },

        // manufacturing entries
        fetchManufacturingBondEntries(bondId){
            // this.loading = true;
            return this.$store.dispatch('manufacturing/fetchAllEntries', {
                manufacturingFileId: bondId
            })
            .finally(() => {
                // this.loading = false;
            })
        },

        confirmDeleteEntry(entry){
            this.deleteEntryDialog = true;
            this.deleteEntryId = entry.id;
        },

        deleteEntry(){
            this.$store.dispatch('manufacturing/deleteEntry', {
                manufacturingFileId: this.$route.query.id,
                entryId: this.deleteEntryId,
            })
            .then(() => {
                this.fetchManufacturingBondEntries(this.$route.query.id);
            })
        },

        // handlers
        showDetails(entry){
            console.log(entry)
            this.$router.push({name: 'show-product', query: {
                manufacturingFileId: this.$route.query.id,
                entryId: entry.id,
            }})
        },

        editRawMaterials(entry){
            this.$router.push({name: 'edit-product', query: {
                manufacturingFileId: this.$route.query.id,
                entryId: entry.id
            }})
        },
        fetchMaterials(isUpdate = true) {
            this.materialsLoading = true;
            return this.$store.dispatch('materials/fetchAll').then(() => {
                this.materialsLoading = false;
                if(isUpdate) {
                    EventBus.$emit('notification', this.$t('update-materials-notifications'))
                }
            });
        },
    },
    
    // async beforeRouteEnter(to, from, next) {
    //     let promises = [];

    //     let materials = store.state.materials.materials;
    //     if(materials && materials.length === 0){
    //         promises.push(store.dispatch("materials/fetchAll"));
    //     }

    //     let warehouses = store.state.warehouses.warehouses;
    //     if(Object.keys(warehouses).length === 0){
    //         promises.push(store.dispatch("warehouses/fetchAll"));
    //     }

    //     let unitSizes = store.state.unitSizes.unit_sizes;
    //     if(Object.keys(unitSizes).length === 0){
    //         promises.push(store.dispatch("unitSizes/fetchAll"));
    //     }

    //     await Promise.all(promises);

    //     next((vm) => {
    //         store.dispatch('manufacturing/fetchAll', {
    //             fromDate: store.state.configs.configs.financial_file.start_date,
    //             toDate: new Date ().toISOString().substring(0, 10),
    //             postingStatus: 3 // 3 => all bonds
    //         })
    //         .then(() => {
    //             if (vm.$route.query.id){
    //                 vm.fetchManufacturingBond(vm.$route.query.id);
    //             }
    //             else {
    //                 const lastManufacturingBondId =
    //                 vm.manufacturingBonds[vm.manufacturingBonds.length -1].id;
    //                 vm.$router.replace({ name: 'manufacturing-bond', query: { id: lastManufacturingBondId } })
    //                 .then(() => {
    //                     vm.fetchManufacturingBond(lastManufacturingBondId);
    //                 })
    //             }
    //         })
    //     });
    // },

    mounted(){
        this.loading = true;
        window.observer.observe(document.querySelector("#tool-bar"));
        window.observer.observe(document.querySelector("#footer"));
                let promises = [];

        let materials = store.state.materials.materials;
        if(materials && materials.length === 0){
            promises.push(this.fetchMaterials(false));
        }

        let warehouses = store.state.warehouses.warehouses;
        if(Object.keys(warehouses).length === 0){
            promises.push(store.dispatch("warehouses/fetchAll"));
        }

        let unitSizes = store.state.unitSizes.unit_sizes;
        if(Object.keys(unitSizes).length === 0){
            promises.push(store.dispatch("unitSizes/fetchAll"));
        }

        Promise.all(promises)
        .then(() => {
            store.dispatch('manufacturing/fetchAll', {
                fromDate: store.state.configs.configs.financial_file.start_date,
                toDate: new Date ().toISOString().substring(0, 10),
                postingStatus: 3 // 3 => all bonds
            })
            .then(() => {
                if (this.$route.query.id){
                    this.fetchManufacturingBond(this.$route.query.id);
                }
                else {
                    const lastManufacturingBondId =
                    this.manufacturingBonds[this.manufacturingBonds.length -1]?.id;
                    this.$router.replace({ name: 'manufacturing-bond', query: { id: lastManufacturingBondId } })
                    .then(() => {
                        this.fetchManufacturingBond(lastManufacturingBondId);
                    })
                }
            })
        });
    }
}
</script>

<style scoped>
.border {
	border: 1px solid #f1f1f1;
    border-radius: 8px;
}
</style>